import type { FeatureModule } from '@store/features/types';

import ledgerDrawerReducer from './slice';

/**
 * Patient Ledger feature module — single UI slice for the global drawer
 * state. No persistence (the drawer is transient session UI), no
 * cross-tab sync (each tab manages its own drawer).
 */
export const patientLedgerFeature: FeatureModule = {
  id: 'patient-ledger',
  name: 'Patient Ledger',
  dependencies: [],
  reducers: {
    'patientLedger/drawer': ledgerDrawerReducer,
  },
  middleware: [],
};
